export default [
    // ================ Brands ================
    {
        name: "brandw_index",
        path: "/website/brand",
        component: () => import("../pages/website/brands/index.vue"),
    },
    {
        name: "brandw_create",
        path: "/website/brand/create",
        component: () => import("../pages/website/brands/manage.vue"),
    },
    {
        name: "brandw_update",
        path: "/website/brand/update/:id",
        component: () => import("../pages/website/brands/manage.vue"),
    },
    // ================ Category (P26_018 FR-13) ================
    {
        name: "categoryw_index",
        path: "/website/category",
        component: () => import("../pages/website/category/index.vue"),
    },
    {
        name: "categoryw_update",
        path: "/website/category/update/:id",
        component: () => import("../pages/website/category/manage.vue"),
    },
    // ================ Video (P26_018 FR-15) ================
    {
        name: "videow_index",
        path: "/website/video",
        component: () => import("../pages/website/video/index.vue"),
    },
    {
        name: "videow_create",
        path: "/website/video/upload",
        component: () => import("../pages/website/video/manage.vue"),
    },
    {
        name: "videow_edit",
        path: "/website/video/upload/:id",
        component: () => import("../pages/website/video/manage.vue"),
    },
    // ================ Store Location ================
    {
        name: "storelocw_index",
        path: "/website/store",
        component: () => import("../pages/website/store/index.vue"),
    },
    {
        name: "storelocw_create",
        path: "/website/store/create",
        component: () => import("../pages/website/store/manage.vue"),
    },
    {
        name: "storelocw_update",
        path: "/website/store/update/:id",
        component: () => import("../pages/website/store/manage.vue"),
    },
    // ================ Member ================
    {
        name: "memberw_index",
        path: "/website/member",
        component: () => import("../pages/website/member/index.vue"),
    },
    {
        name: "memberw_create",
        path: "/website/member/create",
        component: () => import("../pages/website/member/manage.vue"),
    },
    {
        name: "memberw_update",
        path: "/website/member/update/:id",
        component: () => import("../pages/website/member/manage.vue"),
    },
    {
        name: "memberw_view",
        path: "/website/member/:id",
        component: () =>
            import("../pages/homepage/website/performanceMemberDetail.vue"),
    },
    // ================ Keyword Tag ================
    {
        name: "keywordtagw_index",
        path: "/website/keyword-tag",
        component: () => import("../pages/website/keywordTag/index.vue"),
    },
    {
        name: "keywordtagw_create",
        path: "/website/keyword-tag/create",
        component: () => import("../pages/website/keywordTag/manage.vue"),
    },
    {
        name: "keywordtagw_update",
        path: "/website/keyword-tag/update/:id",
        component: () => import("../pages/website/keywordTag/manage.vue"),
    },
    // ================ Search Bar ================
    // {
    //     name: "storelocw_update",
    //     path: "/website/search-bar-product",
    //     component: () => import("../pages/website/searchBarProduct/index.vue")
    // },
    // {
    //     name: "storelocw_update",
    //     path: "/website/search-bar-product/create",
    //     component: () => import("../pages/website/searchBarProduct/manage.vue")
    // },
    // {
    //     name: "storelocw_update",
    //     path: "/website/search-bar-product/update/:id",
    //     component: () => import("../pages/website/searchBarProduct/manage.vue")
    // },
    // {
    //     name: "storelocw_update",
    //     path: "/website/search-placeholder",
    //     component: () => import("../pages/website/searchPlaceholder/index.vue")
    // },
    // ================ Badge ================
    {
        name: "badge_index",
        path: "/website/badge",
        component: () => import("../pages/website/promoBadge/index.vue"),
    },
    {
        name: "badge_create",
        path: "/website/badge/create",
        component: () => import("../pages/website/promoBadge/manage.vue"),
    },
    {
        name: "badge_update",
        path: "/website/badge/update/:id",
        component: () => import("../pages/website/promoBadge/manage.vue"),
    },
    // ================ Email Queue ================
    {
        name: "emailqueue_index",
        path: "/website/email",
        component: () => import("../pages/website/email/index.vue"),
    },
    {
        name: "emailqueue_campaign",
        path: "/website/email-campaign",
        component: () => import("../pages/website/email/campaign.vue"),
    },
    {
        name: "emailqueue_awareness",
        path: "/website/email-awareness",
        component: () => import("../pages/website/email/awareness.vue"),
    },
    // ================ Orders ================
    {
        name: "orderw_index",
        path: "/website/orders",
        component: () => import("../pages/website/orders/index.vue"),
    },
    // ================ Product ================
    {
        name: "productw_index",
        path: "/website/product",
        component: () => import("../pages/website/product/index.vue"),
    },
    {
        name: "productw_create",
        path: "/website/product/create",
        component: () => import("../pages/website/product/create.vue"),
    },
    {
        name: "productvariantw_duplicate",
        path: "/website/product/duplicate-variant",
        component: () => import("../pages/website/product/singleVariant.vue"),
    },
    {
        name: "productvariantw_update",
        path: "/website/product/update-variant",
        component: () => import("../pages/website/product/singleVariant.vue"),
    },
    {
        name: "productvariantw_create",
        path: "/website/product/create-variant",
        component: () => import("../pages/website/product/singleVariant.vue"),
    },
    {
        name: "productw_update",
        path: "/website/product/update/:id",
        component: () => import("../pages/website/product/updateProduct.vue"),
    },
    // ================ Promotion Sugest ================
    {
        name: "promotionsugest_index",
        path: "/website/promotion-sugest",
        component: () => import("../pages/website/promotionSugest/index.vue"),
    },
    {
        name: "promotionsugest_create",
        path: "/website/promotion-sugest/create",
        component: () => import("../pages/website/promotionSugest/manage.vue"),
    },
    {
        name: "promotionsugest_update",
        path: "/website/promotion-sugest/update/:id",
        component: () => import("../pages/website/promotionSugest/manage.vue"),
    },
    // =================== Banner Popup ====================
    {
        name: "popupbanner_index",
        path: "/website/popup-banner",
        component: () => import("../pages/website/popupBanner/index.vue"),
    },
    {
        name: "popupbanner_create",
        path: "/website/popup-banner/create",
        component: () => import("../pages/website/popupBanner/manage.vue"),
    },
    {
        name: "popupbanner_update",
        path: "/website/popup-banner/update/:id",
        component: () => import("../pages/website/popupBanner/manage.vue"),
    },
    // =================== Free Products ====================
    {
        name: "freeproduct_index",
        path: "/website/free-product",
        component: () => import("../pages/website/freeProduct/index.vue"),
    },
    {
        name: "freeproduct_create",
        path: "/website/free-product/create",
        component: () => import("../pages/website/freeProduct/manage.vue"),
    },
    {
        name: "freeproduct_update",
        path: "/website/free-product/update/:id",
        component: () => import("../pages/website/freeProduct/manage.vue"),
    },
    // =================== Promotion ====================
    {
        name: "promotion_index",
        path: "/website/promotion",
        component: () => import("../pages/website/promotions/index.vue"),
    },
    {
        name: "promotion_regular",
        path: "/website/promotion/regular",
        component: () => import("../pages/website/promotions/regular.vue"),
    },
    {
        name: "promotion_regularcopy",
        path: "/website/promotion/regular/:id/copy",
        component: () => import("../pages/website/promotions/regular.vue"),
    },
    {
        name: "promotion_buyget",
        path: "/website/promotion/buy-get",
        component: () => import("../pages/website/promotions/buyGet.vue"),
    },
    {
        name: "promotion_buygetcopy",
        path: "/website/promotion/buy-get/:id/copy",
        component: () => import("../pages/website/promotions/buyGet.vue"),
    },
    {
        name: "promotion_minqty",
        path: "/website/promotion/min-qty",
        component: () => import("../pages/website/promotions/minQty.vue"),
    },
    {
        name: "promotion_minqtyupdate",
        path: "/website/promotion/min-qty/update/:id",
        component: () => import("../pages/website/promotions/minQty.vue"),
    },
    {
        name: "promotion_minqtycopy",
        path: "/website/promotion/min-qty/:id/copy",
        component: () => import("../pages/website/promotions/minQty.vue"),
    },
    {
        name: "promotion_vouchercreate",
        path: "/website/promotion/voucher",
        component: () => import("../pages/website/promotions/voucher.vue"),
    },
    {
        name: "promotion_vouchercopy",
        path: "/website/promotion/voucher/:id/copy",
        component: () => import("../pages/website/promotions/voucher.vue"),
    },
    {
        name: "promotion_shippingcreate",
        path: "/website/promotion/shipping",
        component: () => import("../pages/website/promotions/shipping.vue"),
    },
    {
        name: "promotion_shippingcopy",
        path: "/website/promotion/shipping/:id/copy",
        component: () => import("../pages/website/promotions/shipping.vue"),
    },
    {
        name: "promotion_pwpcreate",
        path: "/website/promotion/pwp",
        component: () => import("../pages/website/promotions/pwp.vue"),
    },
    {
        name: "promotion_pwpcopy",
        path: "/website/promotion/pwp/:id/copy",
        component: () => import("../pages/website/promotions/pwp.vue"),
    },
    {
        name: "promotion_freeitem",
        path: "/website/promotion/free-item",
        component: () => import("../pages/website/promotions/freeItem.vue"),
    },
    {
        name: "promotion_freeitemcopy",
        path: "/website/promotion/free-item/:id/copy",
        component: () => import("../pages/website/promotions/freeItem.vue"),
    },
    // ================ Shipping Tracking ================
    {
        name: "shippingantrw_index",
        path: "/website/shipping/anteraja",
        component: () => import("../pages/website/shipping/anteraja.vue"),
    },
    {
        name: "shippinggosendw_list",
        path: "/website/shipping/gosend",
        component: () => import("../pages/website/shipping/gosend.vue"),
    },
    {
        name: "shippinglalamovew_index",
        path: "/website/shipping/lalamove",
        component: () => import("../pages/website/shipping/lalamove.vue"),
    },
    // ================ Shipping Tracking ================
    {
        name: "refundw_index",
        path: "/website/refund",
        component: () => import("../pages/website/refund/index.vue"),
    },

    // ================ P26_0034 Loyalty penukaran hadiah ================
    {
        name: "loyaltyredemptionw_index",
        path: "/website/loyalty-redemption",
        component: () => import("../pages/website/loyaltyRedemption/index.vue"),
    },

    {
        name: "subsproduct_index",
        path: "/website/product-subs",
        component: () => import("../pages/website/subscription/index.vue"),
    },
    {
        name: "subsproduct_create",
        path: "/website/product-subs/create",
        component: () => import("../pages/website/subscription/manage.vue"),
    },
    {
        name: "subsproduct_update",
        path: "/website/product-subs/update/:id",
        component: () => import("../pages/website/subscription/manage.vue"),
    },
    {
        name: "subsorder_index",
        path: "/website/orders-subs",
        component: () =>
            import("../pages/website/subscription/orders/index.vue"),
    },
    {
        name: "mccampaign_id",
        path: "/website/mailchimp/campaign",
        component: () =>
            import("../pages/website/mailchimp/campaign/index.vue"),
    },
    // ================ Diseases ================
    {
        name: "diseases_index",
        path: "/website/diseases",
        component: () => import("../pages/website/diseases/index.vue"),
    },
    {
        name: "diseases_create",
        path: "/website/diseases/create",
        component: () => import("../pages/website/diseases/manage.vue"),
    },
    {
        name: "diseases_update",
        path: "/website/diseases/update/:id",
        component: () => import("../pages/website/diseases/manage.vue"),
    },
    // ================ Landing Page Builder ================
    {
        name: "promotionpage_index",
        path: "/website/promotion-page",
        component: () => import("../pages/website/landingPage/index.vue"),
    },
    {
        name: "promotionpage_create",
        path: "/website/promotion-page/create",
        component: () => import("../pages/website/landingPage/manage.vue"),
    },
    {
        name: "promotionpage_update",
        path: "/website/promotion-page/update/:id",
        component: () => import("../pages/website/landingPage/manage.vue"),
    },
    // ================ Member Blacklist ================
    {
        name: "memberblacklist_index",
        path: "/website/member-blacklist",
        component: () => import("../pages/website/memberBlacklist/index.vue"),
    },
    {
        name: "memberblacklist_create",
        path: "/website/member-blacklist/create",
        component: () => import("../pages/website/memberBlacklist/manage.vue"),
    },
    {
        name: "memberblacklist_update",
        path: "/website/member-blacklist/update/:id",
        component: () => import("../pages/website/memberBlacklist/manage.vue"),
    },
    // ================ Redirect Link ================
    {
        name: "redirectw_index",
        path: "/website/seo/redirect",
        component: () => import("../pages/website/redirect/index.vue"),
    },
    {
        name: "redirectw_create",
        path: "/website/seo/redirect/create",
        component: () => import("../pages/website/redirect/manage.vue"),
    },
    {
        name: "redirectw_update",
        path: "/website/seo/redirect/update/:id",
        component: () => import("../pages/website/redirect/manage.vue"),
    },
    // ================ Slider Banner ================
    {
        name: "sliderbanner_index",
        path: "/website/slider-banner",
        component: () => import("../pages/website/sliderbanner/index.vue"),
    },
    {
        name: "sliderbanner_create",
        path: "/website/slider-banner/create",
        component: () => import("../pages/website/sliderbanner/manage.vue"),
    },
    {
        name: "sliderbanner_update",
        path: "/website/slider-banner/update/:id",
        component: () => import("../pages/website/sliderbanner/manage.vue"),
    },

    // ================ Article Category ================
    {
        name: "articlescategory_index",
        path: "/website/article-category",
        component: () => import("../pages/website/articleCategory/index.vue"),
    },
    {
        name: "articlescategory_create",
        path: "/website/article-category/create",
        component: () => import("../pages/website/articleCategory/manage.vue"),
    },
    {
        name: "articlescategory_update",
        path: "/website/article-category/update/:id",
        component: () => import("../pages/website/articleCategory/manage.vue"),
    },
    // ================ Article Blog ================
    {
        name: "articlesblog_index",
        path: "/website/article-blog",
        component: () => import("../pages/website/articleBlog/index.vue"),
    },
    {
        name: "articlesblog_create",
        path: "/website/article-blog/create",
        component: () => import("../pages/website/articleBlog/manage.vue"),
    },
    {
        name: "articlesblog_update",
        path: "/website/article-blog/update/:slug",
        component: () => import("../pages/website/articleBlog/manage.vue"),
    },
    // ================ Article Blog ================
    {
        name: "articlespromotion_index",
        path: "/website/article-promotion",
        component: () => import("../pages/website/articlePromotion/index.vue"),
    },
    {
        name: "articlespromotion_create",
        path: "/website/article-promotion/create",
        component: () => import("../pages/website/articlePromotion/manage.vue"),
    },
    {
        name: "articlespromotion_update",
        path: "/website/article-promotion/update/:id",
        component: () => import("../pages/website/articlePromotion/manage.vue"),
    },
    // ================ Featured ================
    {
        name: "featured_index",
        path: "/website/featured",
        component: () => import("../pages/website/featured/index.vue"),
    },
    // ================ Best Seller ================
    {
        name: "bestseller_index",
        path: "/website/best-seller",
        component: () => import("../pages/website/bestseller/index.vue"),
    },
    // ================= Flash Sale =================
    {
        name: "flashsale_index",
        path: "/website/flashsale",
        component: () => import("../pages/website/flashsale/index.vue"),
    },
    {
        name: "flashsale_create",
        path: "/website/flashsale/create",
        component: () => import("../pages/website/flashsale/manage.vue"),
    },
    {
        name: "flashsale_update",
        path: "/website/flashsale/update/:id",
        component: () => import("../pages/website/flashsale/manage.vue"),
    },
    // ================ Smart Promo Collection ================
    {
        name: "smartpromo_index",
        path: "/website/smart-promo",
        component: () => import("../pages/website/smartPromo/index.vue"),
    },
    {
        name: "smartpromo_create",
        path: "/website/smart-promo/create",
        component: () => import("../pages/website/smartPromo/manage.vue"),
    },
    {
        name: "smartpromo_update",
        path: "/website/smart-promo/update/:id",
        component: () => import("../pages/website/smartPromo/manage.vue"),
    },
    // ================ Expedition Method (Metode Pengiriman) ================
    {
        name: "expedition_index",
        path: "/website/expedition-method",
        component: () => import("../pages/website/expeditionMethod/index.vue"),
    },
    {
        name: "expedition_detail",
        path: "/website/expedition-method/detail/:id",
        component: () => import("../pages/website/expeditionMethod/manage.vue"),
    },
    // ================ New Product ================
    {
        name: "newproduct_index",
        path: "/website/new-product",
        component: () => import("../pages/website/newproduct/index.vue"),
    },
    {
        name: "newproduct_create",
        path: "/website/new-product/create",
        component: () => import("../pages/website/newproduct/manage.vue"),
    },
    {
        name: "newproduct_update",
        path: "/website/new-product/update/:id",
        component: () => import("../pages/website/newproduct/manage.vue"),
    },
    // ================ Review ================
    {
        name: "review_index",
        path: "/website/review",
        component: () => import("../pages/website/review/index.vue"),
    },
    // ================ Discussion ================
    {
        name: "discussion_index",
        path: "/website/discussion",
        component: () => import("../pages/website/discussion/index.vue"),
    },

    // ================ Contact Us ================
    {
        name: "contactus_index",
        path: "/website/contact-us",
        component: () => import("../pages/website/contactUs/index.vue"),
    },
    // ================ SEO MENU ================
    {
        name: "seomenu_index",
        path: "/website/seo/menu",
        component: () => import("../pages/website/seo/menu/index.vue"),
    },
    {
        name: "seomenu_update",
        path: "/website/seo/menu/update/:id",
        component: () => import("../pages/website/seo/menu/manage.vue"),
    },
    // ================ SEO CATEGORY ================
    {
        name: "seocategory_index",
        path: "/website/seo/category",
        component: () => import("../pages/website/seo/category/index.vue"),
    },
    // ================ SEO PRODUCT ================
    {
        name: "seoproduct_index",
        path: "/website/seo/product",
        component: () => import("../pages/website/seo/product/index.vue"),
    },
    {
        name: "seoproduct_update",
        path: "/website/seo/product/update/:id",
        component: () => import("../pages/website/seo/product/manage.vue"),
    },
    // ================ SEO BRAND ================
    {
        name: "seobrand_index",
        path: "/website/seo/brand",
        component: () => import("../pages/website/seo/brand/index.vue"),
    },
    {
        name: "seobrand_update",
        path: "/website/seo/brand/update/:id",
        component: () => import("../pages/website/seo/brand/manage.vue"),
    },
    // ================ SEO DISEASE ================
    {
        name: "seodisease_index",
        path: "/website/seo/disease",
        component: () => import("../pages/website/seo/disease/index.vue"),
    },
    {
        name: "seodisease_update",
        path: "/website/seo/disease/update/:id",
        component: () => import("../pages/website/seo/disease/manage.vue"),
    },
    // ================ Notification ================
    {
        name: "notifholiday_index",
        path: "/website/notification/holiday",
        component: () => import("../pages/website/notification/holiday/index.vue"),
    },
    {
        name: "notifmember_index",
        path: "/website/notification/member",
        component: () => import("../pages/website/notification/member/index.vue"),
    },
    // ================ Health Tools ================
    {
        name: "healthtools_index",
        path: "/website/health-tools",
        component: () => import("../pages/website/healthTools/index.vue"),
    },
    {
        name: "healthtools_update",
        path: "/website/health-tools/update/:id",
        component: () => import("../pages/website/healthTools/manage.vue"),
    },
    {
        name: "healthtools_users_index",
        path: "/website/health-tools-users",
        component: () => import("../pages/website/healthTools/users.vue"),
    },
    // ================ Referral ==================
    {
        name: "referral_index",
        path: "/website/referral",
        component: () => import("../pages/website/referral/index.vue"),
    },
]